"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserValidator = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _BaseValidator = require("../BaseValidator/BaseValidator");
function fullName(str) {
  var _str$split = str.split(' '),
    _str$split2 = (0, _slicedToArray2["default"])(_str$split, 2),
    first = _str$split2[0],
    last = _str$split2[1];
  if (!first || !last || !(0, _BaseValidator.name)(first) || !(0, _BaseValidator.name)(last)) return false;
  return true;
}
function getPasswordTooltipValidation(value) {
  var userPasswordTooltipValidation = [{
    valid: true,
    message: '12 to 32 characters'
  }, {
    valid: true,
    message: 'An uppercase & lowercase letter'
  }, {
    valid: true,
    message: 'At least one symbol (!@#$%^&*())'
  }, {
    valid: true,
    message: 'At least one number'
  }];
  if (!(0, _BaseValidator.passwordLength)(value)) {
    userPasswordTooltipValidation[0].valid = false;
  }
  if (!(0, _BaseValidator.passwordCase)(value)) {
    userPasswordTooltipValidation[1].valid = false;
  }
  if (!(0, _BaseValidator.passwordSymbols)(value)) {
    userPasswordTooltipValidation[2].valid = false;
  }
  if (!(0, _BaseValidator.passwordNumbers)(value)) {
    userPasswordTooltipValidation[3].valid = false;
  }
  return userPasswordTooltipValidation;
}
var UserValidator = exports.UserValidator = {
  fullName: fullName,
  name: _BaseValidator.name,
  teamName: _BaseValidator.teamName,
  heardAbout: _BaseValidator.heardAbout,
  email: _BaseValidator.email,
  phone: _BaseValidator.phone,
  password: _BaseValidator.password,
  passwordLength: _BaseValidator.passwordLength,
  passwordCase: _BaseValidator.passwordCase,
  passwordSymbols: _BaseValidator.passwordSymbols,
  passwordNumbers: _BaseValidator.passwordNumbers,
  confirmPassword: _BaseValidator.confirmPassword,
  getPasswordTooltipValidation: getPasswordTooltipValidation,
  nameLength: _BaseValidator.nameLength,
  forbiddenXSSCharacters: _BaseValidator.forbiddenXSSCharacters,
  isUrl: _BaseValidator.isUrl
};